"use client";

import { useQuery } from "@tanstack/react-query";
import uniq from "lodash/uniq";
import { useAdmin } from "logic/components";
import { useMemo } from "react";
import { Address } from "viem";

import { getSignerWalletLabels } from "./getSignerWalletLabels";

/** Borrower names keyed by lowercased wallet address. Only fetched in admin mode. */
export function useSignerWalletLabels(addresses: Address[]) {
  const { isAdminMode } = useAdmin();

  // Sorted so that reordering the wallet list doesn't refetch under a new key.
  const wallets = useMemo(() => uniq(addresses).sort(), [addresses]);

  const { data: labels = {}, isLoading } = useQuery({
    queryKey: ["signerWalletLabels", wallets] as const,
    queryFn: ({ queryKey: [, queried] }) => getSignerWalletLabels(queried),
    enabled: isAdminMode && wallets.length > 0,
    refetchOnWindowFocus: false,
  });

  return { labels, isLoading };
}
